export default {
	state: {
	},
	mutations: {
	},
	actions: {
	},
	modules: {
	}
};